import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import {
  getNationalHeadList,
  getPendingListWithFilterData,
  getProducts,
  getStateHeadList,
  getStateHeadTMById,
  getStateOfStateHead,
  getTerritoriesById,
} from '../../../constants/apiCalls';
import tableExcel from '../../../images/tableExcel.png';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import lodash from 'lodash';
import './index.css';
import { Roles } from '../../../constants/Roles';
import Storage from '../../../services/Storage';

const UserFilters = ({
  pageNo,
  page,
  setPage,
  pageSize,
  setPageSize,
  userData,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  dealerData,
  excelData,
}) => {
  const params = useParams();
  const location = useLocation();
  let userInfo = Storage.getUserInfoDetail();
  let userId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';

  const [isLoading, setIsloading] = useState(false);
  const [isPageLoaded, setPageLoaded] = useState(false);

  // Pending Filter
  const [statusId, setStatusId] = useState(null);
  const [statusData, setStatusData] = useState([]);

  // National Head
  const [nhList, setNhList] = useState([]);
  const [nhId, setnhId] = useState('');

  // State Head
  const [shList, setShList] = useState([]);
  const [shId, setShId] = useState('');

  // State
  const [stateFilterList, setStateFilterList] = useState([]);
  const [stateId, setStateId] = useState('');

  // TM
  const [tmList, setTmList] = useState([]);
  const [tmFilterList, setTmFilterList] = useState([]);
  const [tmListAll, setTmListAll] = useState([]);
  const [tmId, setTmId] = useState('');

  // Territory
  const [territoryList, setTerritoryList] = useState([]);
  const [territoryFilterList, setTerritoryFilterList] = useState([]);
  const [territoryId, setTerritoryId] = useState('');

  // Approved app - App Upload
  const [uploadApp, setUploadApp] = useState('');

  // Order Summary Product
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState('');

  // Dealer List kys and status
  const [statusVal, setStatusVal] = useState(
    `${params.pagetype !== 'all' ? params.pagetype : ''}`,
  );
  const [kyc, setKyc] = useState('');

  // Search
  const [userQuery, setUserQuery] = useState('');

  const [searchQuery, setSearchQuery] = useState('');

  const [obj, setObj] = useState({});

  const sendQuery = (query) => {
    setSearchQuery(query);
  };
  const delayedQuery = useCallback(
    lodash.debounce((q) => sendQuery(q), 1000),
    [],
  );
  const storagePage = () => {
    if (location) {
      if (location.pathname.includes('open-meeting')) {
        Storage.setOpenMeetingPage(1);
      } else if (location.pathname.includes('meeting-history')) {
        Storage.setMeetingHistoryPage(1);
      } else if (location.pathname.includes('pipeline')) {
        Storage.setPipelinePage(1);
      } else if (location.pathname.includes('approved-app')) {
        Storage.setAppprovePage(1);
      } else if (location.pathname.includes('rejected-app')) {
        Storage.setRejectPage(1);
      } else if (location.pathname.includes('order-summary')) {
        Storage.setOrderPage(1);
      } else if (location.pathname.includes('birth-day')) {
        Storage.setBirthdayPage(1);
      } else if (location.pathname.includes('m-anniversary')) {
        Storage.setMAnniversaryPage(1);
      } else if (location.pathname.includes('work-anniversary')) {
        Storage.setWorkAnniversaryPage(1);
      } else if (location.pathname.includes('dealer-list')) {
        Storage.setDealerListPage(1);
      }
    }
  };

  useEffect(() => {
    setIsloading(true);
    if (isPageLoaded) {
      let obj = {
        page,
        pageSize,
        uploadApp,
        statusId,
        nhId,
        shId,
        stateId,
        tmId,
        territoryId,
        productId,
        statusVal,
        kyc,
        startDate,
        endDate,
        searchQuery,
      };
      setObj(obj);
      dealerData(obj, page, pageSize);
    }
    setIsloading(false);
  }, [
    isPageLoaded,
    uploadApp,
    statusId,
    nhId,
    shId,
    stateId,
    tmId,
    territoryId,
    productId,
    statusVal,
    kyc,
    startDate,
    endDate,
    searchQuery,
  ]);

  const getPendingListData = () => {
    getPendingListWithFilterData((res) => {
      const { data, success, error } = res;
      if (success === true) {
        let filterData =
          data && data.length > 0 ? data.filter((elem) => elem.id !== 5) : [];
        if (location && location.pathname.includes('rejected-app')) {
          setStatusData(filterData);
        } else {
          setStatusData(data);
        }
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
      }
      setIsloading(false);
      if (roleName === Roles.TM_NAME) {
        setTimeout(() => {
          setPageLoaded(true);
        }, 1);
      }
    });
  };
  const getProductsDetail = () => {
    getProducts((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setProduct(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        setIsloading(false);
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
      }
      setIsloading(false);
      if (roleName === Roles.TM_NAME) {
        setTimeout(() => {
          setPageLoaded(true);
        }, 1);
      }
    });
  };

  // TH Role
  useEffect(() => {
    if (roleName === Roles.TM_NAME) {
      let payload = {
        id: userId,
      };
      getTerritoriesById((res) => {
        const { data, success, error } = res;
        if (success === true) {
          setTerritoryList(data);
          setTerritoryFilterList(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);

      setTimeout(() => {
        setPageLoaded(true);
      }, 1);
    }
    if (
      (location && location.pathname.includes('pipeline')) ||
      (location && location.pathname.includes('rejected-app'))
    ) {
      getPendingListData();
    }
    if (location && location.pathname.includes('order-summary')) {
      getProductsDetail();
    }
  }, [userId]);

  // SH Role
  useEffect(() => {
    if (roleName === Roles.SH_NAME) {
      let tempTmid = null;
      let tempStateid = null;

      let statebyShPayload = {
        id: userId,
      };
      getStateOfStateHead((res) => {
        const { data, success, error } = res;
        if (success === true) {
          if (data && data.length > 0 && data[0].id) {
            tempStateid = data[0].id;
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, statebyShPayload);

      let selectedId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'TM')
          : [];

      if (selectedId && selectedId.length > 0) {
        tempTmid = selectedId[0].id;
        setTmId(selectedId[0].id);
      }

      let payload = {
        id: userId,
      };

      getStateHeadTMById((res) => {
        const { data, success, error } = res;
        if (success === true) {
          let filterData = data && data.length > 0 ? data[0] : [];
          if (filterData && filterData.state) {
            setStateFilterList(filterData.state);
          }

          if (filterData && filterData.territory_manager) {
            setTmListAll(filterData.territory_manager); // have duplicate tm
            setTmList([
              ...new Map(
                filterData.territory_manager.map((m) => [m.user_id, m]),
              ).values(),
            ]); // removed dulpicate tm
            setTmFilterList([
              ...new Map(
                filterData.territory_manager.map((m) => [m.user_id, m]),
              ).values(),
            ]); // removed dulpicate tm
          }

          if (filterData && filterData.territory) {
            setTerritoryList(filterData.territory);
            if (tempTmid && filterData.territory_manager) {
              let filterTmbyId = filterData.territory_manager.filter(
                (e) => e.user_id === tempTmid,
              );
              let territoryIdArr = filterTmbyId
                ? filterTmbyId.map((e) => e.territory_id)
                : [];
              let territoryArr = filterData.territory.filter((e) =>
                territoryIdArr.includes(e.territory_id),
              );
              let uniqueTerritoryData =
                territoryArr && territoryArr.length > 0
                  ? [
                      ...new Map(
                        territoryArr.map((m) => [m.territory_id, m]),
                      ).values(),
                    ]
                  : [];
              setTerritoryFilterList(uniqueTerritoryData);
            } else if (tempStateid) {
              let filterTerritorybyState = filterData.territory.filter(
                (e) => e.state_id === tempStateid,
              );
              setTerritoryFilterList(filterTerritorybyState);
            } else {
              let filteredTMBH = filterData
                ? [
                    ...new Map(
                      filterData.territory.map((m) => [m.territory_id, m]),
                    ).values(),
                  ]
                : [];
              setTerritoryFilterList(filteredTMBH);
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
        setTimeout(() => {
          setPageLoaded(true);
        }, 1);
      }, payload);
    }
  }, [userId]);

  // NH Role
  useEffect(() => {
    if (roleName === Roles.NH_NAME) {
      let tempShid = null;
      let tempTmid = null;
      let tempStateid = null;

      let selectedShId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'SH')
          : [];
      if (selectedShId && selectedShId.length > 0) {
        setShId(selectedShId[0].id);
        tempShid = selectedShId[0].id;
        tempStateid = selectedShId[0].state_id;
        setStateId(selectedShId[0].state_id);
      }

      let selectedTMId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'TM')
          : [];
      if (selectedShId && selectedShId.length > 1) {
        setTmId(selectedShId[0].id);
        tempTmid = selectedShId[0].id;
      } else if (selectedTMId && selectedTMId.length > 0) {
        setTmId(selectedTMId[0].id);
        tempTmid = selectedTMId[0].id;
      }

      let payload = {
        id: userId,
      };
      getStateHeadList((resp) => {
        const { data, success, error } = resp;
        if (success === true) {
          setShList(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);

      let statePayload = {
        id: tempShid || userId,
      };
      getStateHeadTMById((res) => {
        const { data, success, error } = res;
        if (success === true) {
          let filterData = data && data.length > 0 ? data[0] : [];

          if (filterData) {
            if (filterData.state) {
              setStateFilterList(filterData.state);
            }
            if (filterData.territory_manager) {
              setTmListAll(filterData.territory_manager); // have duplicate tm
              setTmList([
                ...new Map(
                  filterData.territory_manager.map((m) => [m.user_id, m]),
                ).values(),
              ]); // removed dulpicate tm
              if (tempStateid && filterData.territory_manager) {
                let filterTmByState = filterData.territory_manager.filter(
                  (e) => e.state_id === tempStateid,
                ); // have duplicate Tm
                let uniqueTmByState =
                  filterTmByState && filterTmByState.length > 0
                    ? [
                        ...new Map(
                          filterTmByState.map((m) => [m.user_id, m]),
                        ).values(),
                      ]
                    : []; //remove duplicate tm
                setTmFilterList(uniqueTmByState);
              } else {
                setTmFilterList([
                  ...new Map(
                    filterData.territory_manager.map((m) => [m.user_id, m]),
                  ).values(),
                ]); // removed dulpicate tm
              }
            }
            if (filterData.territory) {
              setTerritoryList(filterData.territory);
              if (tempTmid && filterData.territory_manager) {
                let filterTmbyId = filterData.territory_manager.filter(
                  (e) => e.user_id === tempTmid,
                );
                let territoryIdArr = filterTmbyId
                  ? filterTmbyId.map((e) => e.territory_id)
                  : [];
                let territoryArr = filterData.territory.filter((e) =>
                  territoryIdArr.includes(e.territory_id),
                );
                let uniqueTerritoryData =
                  territoryArr && territoryArr.length > 0
                    ? [
                        ...new Map(
                          territoryArr.map((m) => [m.territory_id, m]),
                        ).values(),
                      ]
                    : [];
                setTerritoryFilterList(uniqueTerritoryData);
              } else if (tempStateid) {
                let filterTerritorybyState = filterData.territory.filter(
                  (e) => e.state_id === tempStateid,
                );
                setTerritoryFilterList(filterTerritorybyState);
              } else {
                let filteredTMBH = filterData
                  ? [
                      ...new Map(
                        filterData.territory.map((m) => [m.territory_id, m]),
                      ).values(),
                    ]
                  : [];
                setTerritoryFilterList(filteredTMBH);
              }
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
        setTimeout(() => {
          setPageLoaded(true);
        }, 1);
      }, statePayload);
    }else if(roleName === Roles.CNF_ROLE){
      getStateHeadList((resp) => {
        const { data, success, error } = resp;
        if (success === true) {
          setShList(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
        setTimeout(() => {
          setPageLoaded(true);
        }, 1);
      }, {});
    }
  }, [userId]);

  // BH Role
  useEffect(() => {
    if (roleName === Roles.BH_NAME) {
      let tempNhid = null;
      let tempShid = null;
      let tempTmid = null;
      let tempStateid = null;
      let selectedBHNhId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'NH')
          : [];
      if (selectedBHNhId && selectedBHNhId.length > 0) {
        setnhId(selectedBHNhId[0].id);
        tempNhid = selectedBHNhId[0].id;
        tempStateid = selectedBHNhId[0].state_id;
        setStateId(selectedBHNhId[0].state_id);
      }

      let selectedBHShId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'SH')
          : [];

      if (selectedBHNhId && selectedBHNhId.length > 1) {
        setShId(selectedBHNhId[0].id);
        tempShid = selectedBHNhId[0].id;
        tempStateid = selectedBHNhId[0].state_id;
        setStateId(selectedBHNhId[0].state_id);
      } else if (selectedBHShId && selectedBHShId.length > 0) {
        setShId(selectedBHShId[0].id);
        tempShid = selectedBHShId[0].id;
        tempStateid = selectedBHShId[0].state_id;
        setStateId(selectedBHShId[0].state_id);
      }

      let selectedBHTmId =
        userData && userData.length > 0
          ? userData.filter((val) => val.role === 'TM')
          : [];
      if (selectedBHNhId && selectedBHNhId.length > 2) {
        setTmId(selectedBHNhId[0].id);
        tempTmid = selectedBHNhId[0].id;
      } else if (selectedBHShId && selectedBHShId.length > 1) {
        setTmId(selectedBHShId[0].id);
        tempTmid = selectedBHShId[0].id;
      } else if (selectedBHTmId && selectedBHTmId.length > 0) {
        tempTmid = selectedBHTmId[0].id;
        setTmId(selectedBHTmId[0].id);
      }

      let nationalPayload = {
        id: userId,
      };
      getNationalHeadList((rsp) => {
        const { data, success, error } = rsp;
        if (success) {
          setNhList(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, nationalPayload);
      let payload = {
        id: tempNhid || userId,
      };
      getStateHeadList((resp) => {
        const { data, success, error } = resp;
        if (success === true) {
          setShList(data);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
      let statePayload = {
        id: tempShid || tempNhid || userId,
      };
      getStateHeadTMById((res) => {
        const { data, success, error } = res;
        if (success === true) {
          let filterData = data && data.length > 0 ? data[0] : [];
          if (filterData) {
            if (filterData.state) {
              setStateFilterList(filterData.state);
            }
            if (filterData.territory_manager) {
              setTmListAll(filterData.territory_manager); // have duplicate tm
              setTmList([
                ...new Map(
                  filterData.territory_manager.map((m) => [m.user_id, m]),
                ).values(),
              ]); // removed dulpicate tm
              if (tempStateid && filterData.territory_manager) {
                let filterTmByState = filterData.territory_manager.filter(
                  (e) => e.state_id === tempStateid,
                ); // have duplicate Tm
                let uniqueTmByState =
                  filterTmByState && filterTmByState.length > 0
                    ? [
                        ...new Map(
                          filterTmByState.map((m) => [m.user_id, m]),
                        ).values(),
                      ]
                    : []; //remove duplicate tm
                setTmFilterList(uniqueTmByState);
              } else {
                setTmFilterList([
                  ...new Map(
                    filterData.territory_manager.map((m) => [m.user_id, m]),
                  ).values(),
                ]); // removed dulpicate tm
              }
            }
            if (filterData.territory) {
              setTerritoryList(filterData.territory);
              if (tempTmid && filterData.territory_manager) {
                let filterTmbyId = filterData.territory_manager.filter(
                  (e) => e.user_id === tempTmid,
                );
                let territoryIdArr = filterTmbyId
                  ? filterTmbyId.map((e) => e.territory_id)
                  : [];
                let territoryArr = filterData.territory.filter((e) =>
                  territoryIdArr.includes(e.territory_id),
                );
                let uniqueTerritoryData =
                  territoryArr && territoryArr.length > 0
                    ? [
                        ...new Map(
                          territoryArr.map((m) => [m.territory_id, m]),
                        ).values(),
                      ]
                    : [];
                setTerritoryFilterList(uniqueTerritoryData);
              } else if (tempStateid) {
                let filterTerritorybyState = filterData.territory.filter(
                  (e) => e.state_id === tempStateid,
                );
                setTerritoryFilterList(filterTerritorybyState);
              } else {
                let filteredTMBH = filterData
                  ? [
                      ...new Map(
                        filterData.territory.map((m) => [m.territory_id, m]),
                      ).values(),
                    ]
                  : [];
                setTerritoryFilterList(filteredTMBH);
              }
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
        setTimeout(() => {
          setPageLoaded(true);
        }, 1);
      }, statePayload);
    }
  }, [userId]);

  const handleChange = (e) => {
    if (e.target.name === 'nationalHeadName') {
      let val = e.target.value;
      setnhId(val);
      storagePage();
      setPage(1);
      setShId('');
      setStateId('');
      setTmId('');
      setTerritoryId('');
      let nationalPayload = {
        id: val || userId,
      };
      getStateHeadList((rsp) => {
        const { data, success, error } = rsp;
        if (success === true) {
          setShList(data);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, nationalPayload);

      getStateHeadTMById((rsp) => {
        const { data, success, error } = rsp;
        if (success === true) {
          if (data && data.length > 0) {
            let filterData = data[0];
            if (filterData) {
              if (filterData.territory_manager) {
                setTmFilterList([
                  ...new Map(
                    filterData.territory_manager.map((m) => [m.user_id, m]),
                  ).values(),
                ]); // removed dulpicate tm
              }
              if (filterData.state) {
                setStateFilterList(filterData.state);
              }
              if (filterData.territory) {
                let filteredTMBH = filterData
                  ? [
                      ...new Map(
                        filterData.territory.map((m) => [m.territory_id, m]),
                      ).values(),
                    ]
                  : [];
                setTerritoryFilterList(filteredTMBH);
              }
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, nationalPayload);
    }
    if (e.target.name === 'stateHeadName') {
      let val = e.target.value;
      setShId(e.target.value);
      storagePage();
      setPage(1);
      setStateId('');
      setTmId('');
      setTerritoryId('');

      let payload = {
        id: val || nhId || userId,
      };
      getStateHeadTMById((resp) => {
        const { data, success, error } = resp;
        if (success === true) {
          if (data && data.length > 0) {
            if (data[0].state) {
              setStateFilterList(data[0].state);
            }
            if (data[0].territory_manager) {
              setTmListAll(data[0].territory_manager); // have duplicate tm
              setTmList([
                ...new Map(
                  data[0].territory_manager.map((m) => [m.user_id, m]),
                ).values(),
              ]); // removed dulpicate tm
              setTmFilterList([
                ...new Map(
                  data[0].territory_manager.map((m) => [m.user_id, m]),
                ).values(),
              ]); // removed dulpicate tm
            }
            if (data[0].territory) {
              setTerritoryList(data[0].territory);
              setTerritoryFilterList(data[0].territory);
            }
          }
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    }
    if (e.target.name === 'stateName') {
      let val = e.target.value;
      setStateId(val);
      storagePage();
      setPage(1);
      setTmId('');
      setTerritoryId('');
      if (val) {
        let filterTMAll =
          tmListAll && tmListAll.length > 0
            ? tmListAll.filter((elem) => elem.state_id === +val)
            : [];
        let uniqueTm =
          filterTMAll && filterTMAll.length > 0
            ? [...new Map(filterTMAll.map((m) => [m.user_id, m])).values()]
            : [];
        setTmFilterList(uniqueTm);
        let filterTerritory =
          territoryList && territoryList.length > 0
            ? territoryList.filter((elem) => elem.state_id === +val)
            : [];
        setTerritoryFilterList(filterTerritory);
      } else {
        setTmFilterList(tmList);
        let uniqueTerritory =
          territoryList && territoryList.length > 0
            ? [
                ...new Map(
                  territoryList.map((m) => [m.territory_id, m]),
                ).values(),
              ]
            : [];
        setTerritoryFilterList(uniqueTerritory);
      }
    }
    if (e.target.name === 'tmName') {
      let val = e.target.value;
      setTmId(val);
      storagePage();
      setPage(1);
      setTerritoryId('');
      if (val) {
        let filterTM =
          tmListAll && tmListAll.length > 0
            ? tmListAll.filter((elem) => elem.user_id === +val)
            : [];
        let filterTerritoryArr =
          filterTM && filterTM.length > 0
            ? filterTM.map((val) => {
                return val.territory_id;
              })
            : []; // territory id array
        let filterTerritory =
          territoryList && territoryList.length > 0
            ? territoryList.filter((elem) =>
                filterTerritoryArr.includes(elem.territory_id),
              )
            : [];
        let uniqueFilterTerritory =
          filterTerritory && filterTerritory.length > 0
            ? [
                ...new Map(
                  filterTerritory.map((m) => [m.territory_id, m]),
                ).values(),
              ]
            : [];
        setTerritoryFilterList(uniqueFilterTerritory);
      } else {
        let uniqueTerritory =
          territoryList && territoryList.length > 0
            ? [
                ...new Map(
                  territoryList.map((m) => [m.territory_id, m]),
                ).values(),
              ]
            : [];
        setTerritoryFilterList(uniqueTerritory);
      }
    }
    if (e.target.name === 'territoryName') {
      let val = e.target.value;
      setTerritoryId(val);
      storagePage();
      setPage(1);
    }
    if (e.target.name === 'appUpload') {
      setUploadApp(e.target.value);
      storagePage();
      setPage(1);
    }
    if (e.target.name === 'productList') {
      let val = e.target.value;
      setProductId(val);
      storagePage();
      setPage(1);
    }
    if (e.target.name === 'statusList') {
      setStatusVal(e.target.value);
      storagePage();
      setPage(1);
    }
    if (e.target.name === 'kycList') {
      setKyc(e.target.value);
      storagePage();
      setPage(1);
    }
    if (e.target.name === 'startDate') {
      let value = e.target.value;
      setStartDate(value);
      storagePage();
      setPage(1);
    }
    if (e.target.name === 'endDate') {
      let value = e.target.value;
      setEndDate(value);
      storagePage();
      setPage(1);
    }
    if (e.target.name === 'search') {
      let q = e.target.value;
      setUserQuery(q);
      delayedQuery(q);
      if (q) {
        setPage(1);
      } else {
        setPage(Number(pageNo));
      }
    }
  };

  const handleClickExcel = () => {
    excelData(obj, page, pageSize);
  };

  return (
    <div className="filtersBlockWrapper" id="userFilters">
      {
        roleName !== Roles.CNF_ROLE?
        <Row className="align-items-end">
          {/* Pending list filter */}
          {(location && location.pathname.includes('pipeline')) ||
          (location && location.pathname.includes('rejected-app')) ? (
            <Col lg={12}>
              <div className="tab_container d-flex flex-wrap justify-content-lg-end">
                {statusData.length > 0 &&
                  statusData.map((elem, index) => {
                    const { id, label, reject_label, color } = elem;
                    return (
                      <button
                        key={index}
                        type="button"
                        className={`common_button ${
                          (statusId && +statusId) === id ? 'active' : ''
                        }`}
                        onMouseEnter={(e) => {
                          e.target.style.color = '#ffffff';
                          e.target.style.background = color;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = color;
                          e.target.style.background = `#ffffff`;
                        }}
                        style={{
                          color: `${color}`,
                          backgroundColor: '#ffffff',
                          border: `1px solid ${color}`,
                        }}
                        onClick={() => {
                          setStatusId(id);
                          storagePage();
                          setPage(1);
                        }}
                      >
                        {location && location.pathname.includes('pipeline')
                          ? label
                          : reject_label}
                      </button>
                    );
                  })}
              </div>
            </Col>
          ) : (
            ''
          )}
          <Col lg={8}>
            <div className="filtersBlock d-flex flex-wrap">
              {/* National Head */}
              {roleName === Roles.BH_NAME ? (
                <div className="filterDropdown filterInput">
                  <label htmlFor="nationalHeadName">National Head:</label>
                  <select
                    name="nationalHeadName"
                    id="nationalHeadName"
                    value={nhId}
                    onChange={(e) => handleChange(e)}
                  >
                    <option value={''}>All</option>
                    {nhList.length > 0 &&
                      nhList.map((elem, index) => {
                        const { id, first_name, last_name } = elem;
                        return (
                          <option
                            value={id}
                            key={index}
                          >{`${first_name} ${last_name}`}</option>
                        );
                      })}
                  </select>
                </div>
              ) : (
                ''
              )}
              {/* State Head */}
              {(roleName === Roles.BH_NAME || roleName === Roles.NH_NAME || roleName === Roles.CNF_ROLE)? (
                <div className="filterDropdown filterInput">
                  <label htmlFor="stateHeadName">State Head:</label>
                  <select
                    name="stateHeadName"
                    id="stateHeadName"
                    value={shId}
                    onChange={(e) => handleChange(e)}
                  >
                    <option value={''}>All</option>
                    {shList.length > 0 &&
                      shList.map((elem, index) => {
                        const { id, first_name, last_name } = elem;
                        return (
                          <option value={id} key={index}>
                            {first_name} {last_name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              ) : (
                ''
              )}
              {/* State & TM */}
              {roleName === Roles.BH_NAME ||
              roleName === Roles.NH_NAME ||
              roleName === Roles.CNF_ROLE ||
              roleName === Roles.SH_NAME ? (
                <>
                  <div className="filterDropdown filterInput">
                    <label htmlFor="stateName">State:</label>
                    <select
                      name="stateName"
                      id="stateName"
                      value={stateId}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value={''}>All</option>
                      {stateFilterList.length > 0 &&
                        stateFilterList.map((elem, index) => {
                          const { state_id, name } = elem;
                          return (
                            <option value={state_id} key={index}>
                              {name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  <div className="filterDropdown filterInput">
                    <label htmlFor="tmName">Territory Manager:</label>
                    <select
                      name="tmName"
                      id="tmName"
                      value={tmId}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value={''}>All</option>
                      {tmFilterList.length > 0 &&
                        tmFilterList.map((elem, index) => {
                          const { user_id, first_name, last_name } = elem;
                          return (
                            <option value={user_id} key={index}>
                              {first_name} {last_name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </>
              ) : (
                ''
              )}
              {/* Territory */}
              <div className="filterDropdown filterInput">
                <label htmlFor="territoryName">Territory:</label>
                <select
                  name="territoryName"
                  id="territoryName"
                  value={territoryId}
                  onChange={(e) => handleChange(e)}
                >
                  <option value={''}>All</option>
                  {territoryFilterList.length > 0 &&
                    territoryFilterList.map((elem, index) => {
                      // territory_id from getTerritoryid
                      // id : state_head_tm by id
                      const { id = null, territory_id = null, name } = elem;
                      return (
                        <option value={territory_id || id} key={index}>
                          {name}
                        </option>
                      );
                    })}
                </select>
              </div>

              {/* Approved App - Application Upload approved-app */}
              {location && location.pathname.includes('approved-app') ? (
                <div className="filterDropdown filterInput">
                  <label htmlFor="appUpload">Application Upload:</label>
                  <select
                    name="appUpload"
                    id="appUpload"
                    onChange={(e) => handleChange(e)}
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              ) : (
                ''
              )}

              {/* Order Summary Product order-summary */}
              {location && location.pathname.includes('order-summary') ? (
                <div className="filterDropdown filterInput">
                  <label htmlFor="productList">Product:</label>
                  <select
                    name="productList"
                    id="productList"
                    value={productId}
                    onChange={(e) => handleChange(e)}
                  >
                    <option value={''}>All</option>
                    {product.length > 0 &&
                      product.map((elem, index) => {
                        const { id, name } = elem;
                        return (
                          <option value={id} key={index}>
                            {name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              ) : (
                ''
              )}
              {/* dealer list Status and KYC */}
              {location && location.pathname.includes('dealer-list') ? (
                <>
                  <div className="filterDropdown filterInput">
                    <label htmlFor="statusList">Status:</label>
                    <select
                      name="statusList"
                      id="statusList"
                      value={statusVal}
                      // defaultValue={'active'}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value="">All</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                  <div className="filterDropdown filterInput">
                    <label htmlFor="kycList">KYC Due:</label>
                    <select
                      onChange={(e) => handleChange(e)}
                      name="kycList"
                      id="kycList"
                    >
                      <option value="">All</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                </>
              ) : (
                ''
              )}

              {/* Start Date & End date */}
              {location && !location.pathname.includes('dealer-list') ? (
                <>
                  <div className="filterDate filterInput">
                    <label htmlFor="startDate">Start Date:</label>
                    <input
                      type="date"
                      name="startDate"
                      id="startDate"
                      value={startDate}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="filterDate filterInput">
                    <label htmlFor="endDate">End Date:</label>
                    <input
                      type="date"
                      name="endDate"
                      id="endDate"
                      value={endDate}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </>
              ) : (
                ''
              )}
            </div>
          </Col>
          <Col lg={4}>
            <div className="d-flex align-items-center justify-content-lg-end searchInput">
              <input
                name="search"
                autoComplete="off"
                type="text"
                placeholder={'Search by Code, Name or Mobile'}
                id="search"
                onChange={(e) => handleChange(e)}
                value={userQuery}
              />
              <img
                src={tableExcel}
                style={{ cursor: 'pointer' }}
                className="excelImg"
                alt="excel"
                onClick={() => handleClickExcel()}
              />
            </div>
          </Col>
        </Row>
        :<Row className="align-items-left">
          <Col lg={4}>
            <div className="d-flex align-items-center justify-content-lg-left">
              <input
                name="search"
                autoComplete="off"
                type="text"
                placeholder={'Search by Code, Name or Mobile'}
                id="search"
                onChange={(e) => handleChange(e)}
                value={userQuery}
                style={{paddingLeft: '10px'}}
                className='w-100'
              />
              {/* <img
                src={tableExcel}
                style={{ cursor: 'pointer' }}
                className="excelImg"
                alt="excel"
                onClick={() => handleClickExcel()}
              /> */}
            </div>
          </Col>
          {/* <Col lg={2}>
          <img
                src={tableExcel}
                style={{ cursor: 'pointer'}}
                className="excelImg"
                alt="excel"
                onClick={() => handleClickExcel()}
              />
              </Col> */}
        </Row>
      }
      {isLoading && <CustomSpinner />}
    </div>
  );
};

export default React.memo(UserFilters);
